var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_c('label',{staticClass:"time-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('vue-timepicker',{staticClass:"form-control",attrs:{"format":"HH:mm","disabled":_vm.isDisabled},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "),(
      (_vm.inputVal == null || _vm.inputVal.HH === '' || _vm.inputVal.mm === '') &&
        _vm.submitClicked &&
        _vm.isRequired &&
        !_vm.isDisabled
    )?_c('p',{staticClass:"required-message"},[_vm._v("\n    This field is required.\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a7d338","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TimePickerWithLabel.vue
// module id = 744
// module chunks = 0